import { CurrencyRateEndpoints } from '@/modules/accounting/currency-rate/api/currencyRateEndpoints'

/**
 * Currency endpoint instance
 * instantiate currency api class with different api path
 */

export const currencyRateEndpoints = new CurrencyRateEndpoints()
